/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_TaglineInputs */

const en_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship AI features that actually fit your product, not a bolted-on chat widget.`)
};

const ar_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق ميزات ذكاء اصطناعي تتناسب فعلًا مع منتجك, ليست أداة محادثة ملحقة.`)
};

const bn_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার পণ্যের সাথে সত্যিই মানানসই AI ফিচার শিপ করুন, লাগানো চ্যাট উইজেট নয়।`)
};

const de_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Funktionen liefern, die tatsächlich zu Ihrem Produkt passen, kein aufgesetztes Chat-Widget.`)
};

const es_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance funciones de IA que encajen en su producto, no un widget de chat pegado.`)
};

const fr_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez des fonctionnalités IA qui collent à votre produit, pas un widget de chat scotché.`)
};

const pt_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance recursos de IA que combinam com seu produto, não um widget de chat colado.`)
};

const zh_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供真正适合您产品的人工智能功能，而不是附加的聊天小部件。`)
};

const tr_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürününüze gerçekten uyan YZ özellikleri çıkarın, iliştirilmiş bir sohbet widget'ı değil.`)
};

const ru_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпускайте ИИ-фичи, которые правда подходят вашему продукту, а не прикрученный чат-виджет.`)
};

const pl_svc_ai_integration_tagline = /** @type {(inputs: Svc_Ai_Integration_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostarczaj funkcje AI, które faktycznie pasują do Twojego produktu, a nie przykręcany widżet czatu.`)
};

/**
* | output |
* | --- |
* | "Ship AI features that actually fit your product, not a bolted-on chat widget." |
*
* @param {Svc_Ai_Integration_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_tagline = /** @type {((inputs?: Svc_Ai_Integration_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_tagline(inputs)
	if (locale === "bn") return bn_svc_ai_integration_tagline(inputs)
	if (locale === "de") return de_svc_ai_integration_tagline(inputs)
	if (locale === "es") return es_svc_ai_integration_tagline(inputs)
	if (locale === "fr") return fr_svc_ai_integration_tagline(inputs)
	if (locale === "pt") return pt_svc_ai_integration_tagline(inputs)
	if (locale === "zh") return zh_svc_ai_integration_tagline(inputs)
	if (locale === "tr") return tr_svc_ai_integration_tagline(inputs)
	if (locale === "ru") return ru_svc_ai_integration_tagline(inputs)
	if (locale === "pl") return pl_svc_ai_integration_tagline(inputs)
	return en_svc_ai_integration_tagline(inputs)
});
export { svc_ai_integration_tagline as "svc_ai-integration_tagline" }